$(document).ready(function () {
    const lw = document.querySelector('.logos-slide-in').getAttribute('data-logo-width');
    let spv = 0;
    if (window.screen.width * 0.62331 / Number(lw) > 4) spv = 4;
    else spv = Math.floor(window.screen.width * 0.62331 / Number(lw));
    const swiper3 = new Swiper('.swiper-pr', {
        // Optional parameters
        direction: 'horizontal',

        slidesPerView: 3,
        spaceBetween: 40,
        centeredSlides: true,
        loop: true,

        breakpoints: {
            768: {
                slidesPerView: spv,
                centeredSlides: false,
                spaceBetween: 0
            }
        },

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

    });
});